import { Col, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { GetLocalStorageValue } from '../../../../../../_config/adapters/local-storage/get-local-storage-value.adapter';
import CustomButton from '../../../../../../v2-components/Antd/Button';
import CustomCard from '../../../../../../v2-components/Antd/Card';
import CustomLink from '../../../../../../v2-components/Antd/Link';
import { CustomNotification } from '../../../../../../v2-components/Antd/Notification';
import CustomSteps from '../../../../../../v2-components/Antd/Steps';
import LoadingModal from '../../../../../../v2-components/LoadingModal';
import LoadingPage from '../../../../../../v2-components/LoadingPage';
import { PRESCRYPTION_TYPE } from './constants/prescryption-type.constant';
import { homeDeliveryAddress } from './handle/home-delivery-address.handle';
import { pharmacyRetirement } from './handle/pharmacy-retirement.handle';
import { purchaseInfoAdapter } from './handle/purchase-info-adapter.handle';
import { stepsHandle } from './handle/steps.handle';
import { Service } from './service';
import './style.scss';
import CustomImage from '../../../../../../v2-components/Antd/Image';
import { handleOriginalImage } from '../../../../../landing/components/CardProduct/handle/original-image.handle';
import AddProductCart from '../../../../../../components/Commons/Hooks/Functions/AddProductCart';
import { ENV_COMMON, ENV_COUNTRY } from '../../../../../../components/Commons/Hooks/Variables/Enviroment';
import axios from 'axios';

export default function ProfileShoppingDetailPage() {
	const { id, trx_id } = useParams();
	const [isLoading, setIsLoading] = useState(true);
	const [purchase, setPurchase] = useState();
	const [openLoadingModal, setOpenLoadingModal] = useState(false);
	const [isLoadingModal, setIsLoadingModal] = useState(false);
	const [process, setProcess] = useState();
	// const [order, setOrder] = useState();
	const history = useHistory();
	const { token } = GetLocalStorageValue('userMainInfo');
	const { handleAddProductCart } = AddProductCart();

	useEffect(() => {
		Promise.all([new Service().getPurchaseById(token, id), new Service().getOrderById(trx_id)])
			.then(([purchaseData, orderData]) => {
				if (purchaseData.statusCode === 500 || orderData.statusCode === 500) {
					setIsLoading(false);
					CustomNotification({ type: 'error', message: 'Error', description: orderData.message });
					return history.push('/profile-info/shopping-history');
				}
				setPurchase(purchaseData.data);
				// setOrder(orderData.data.order[0]);
				setProcess(orderData.data?.tracking?.[0]?.process);
				setIsLoading(false);
			})
			.catch((error) => {
				console.log(error);
			});
	}, [id, trx_id, history, token]);

	const handleSendOrder = () => {
		setOpenLoadingModal(true);
		setIsLoadingModal(true);
		new Service()
			.resendEmail(purchase?.trx_id)
			.then((response) => {
				setIsLoadingModal(false);
				setOpenLoadingModal(false);
				CustomNotification({ type: 'success', message: 'Orden enviada', description: 'La orden fue reenviada a su dirección de correo' });
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const steps = stepsHandle(process);
	const current = steps.length - 1;
	const purchaseAdapter = purchaseInfoAdapter(purchase);

	const handleReorder = async (items) => {
		try {

			const productList = Array.isArray(items) ? items : [items];
			const pharmacyMap = {};

			productList.forEach((item) => {
				const { pharmacy, id_pharol } = item;
				if (!pharmacyMap[pharmacy]) {
					pharmacyMap[pharmacy] = [];
				}
				pharmacyMap[pharmacy].push(id_pharol);
			});

			const data = Object.entries(pharmacyMap).map(([pharmacy_name, pharol_ids]) => ({
				pharmacy_name,
				pharol_ids,
			}));

			const url = `${ENV_COMMON}/product/${ENV_COUNTRY}/find-by-pharmacy`;

			const response = await axios.post(url, data, {
				headers: {
					"Content-Type": "application/json",
				},
			});

			if (response.data.statusCode === 200) {
				const products = response.data.data;

				for (let i = 0; i < products.length; i++) {
					const currentProduct = products[i];
					const originalItem = productList.find((item) => item.slug === currentProduct.slug);

					if (originalItem) {
						await handleAddProductCart(currentProduct, originalItem.quantity, false);
					}
				}
			}
		} catch (error) {
			console.error(
				"Error in reorder:",
				error.response ? error.response.data : error.message
			);
		}
	};


	if (isLoading) {
		return <LoadingPage />;
	}

	const totalProductsCount = (array) => {
		return array.reduce((total, item) => {
			return total + item?.quantity;
		}, 0);
	};


	return (
		<>
			<Row justify="center" className="shopping-detail-content">
				<Col md={24} xs={22}>
					<Row justify="left">
						<h3>Orden n° {purchase?.trx_id} </h3>
					</Row>
					<Row justify="left">
						<CustomLink className={'link-primary'} to="/profile-info/shopping-history">
							Volver
						</CustomLink>
					</Row>
					<br></br>

					<Row justify="left" gutter={[16, 16]}>
						<Col md={8} xs={24}>
							<h4> Estado de la compra</h4>
							<CustomCard onClick={() => {}} className={'card-primary'}>
								<CustomSteps direction="vertical" items={steps} current={current} className={'custom-step'} />
							</CustomCard>
						</Col>
						<Col md={8} xs={24}>
							<h4> Detalle del pedido</h4>
							<CustomCard onClick={() => {}} className={'card-primary'}>
								<Row justify="end" className={'disabled'}>
									<p> {purchaseAdapter.createdAt}</p>
								</Row>
								<Row justify="left" >
									<h3>Numero de orden: {purchaseAdapter.trx_id}</h3>
								</Row>
								<Row justify="left" className={'item'}>
									<p>Productos: {totalProductsCount(purchase.products)}</p>
								</Row>
								<Row justify="left" className={'item'}>
									<p>Sub Total Productos: ${purchaseAdapter.sub_total}</p>
								</Row>
								<Row justify="left" className={'item'}>
									<p>Envío: ${purchaseAdapter.total_delivery}</p>
								</Row>
								<Row justify="left" className={'item'}>
									<p style={{fontWeight: "500"}}>Total: ${purchaseAdapter.total}</p>
								</Row>
								{/*Hidden until we have the payment method available */}
								{/*<Row justify="left" className={'item'}>*/}
								{/*	<p style={{fontSize: "12px", marginTop:"4px"}}>Forma de pago: ${purchaseAdapter.total}</p>*/}
								{/*</Row>*/}

								<Row justify="left" >
									<h4 className={'title'}>{purchaseAdapter.type_retirement}</h4>
								</Row>
								<Row justify="left" className={'item'}>
									<div>
										<p>Fecha estimada de entrega:</p>
										<p>{purchaseAdapter.schedule_selected}</p>
									</div>
								</Row>
								{pharmacyRetirement(purchase?.info.type_retirement, purchase)}
								<Row justify="left" className={'item'}>
									<div style={{ marginBottom: '11px' }}>
										<h4 className={'title'}>
											{purchaseAdapter.first_name} {purchaseAdapter.last_name}
										</h4>
										<p>{purchaseAdapter.rut}</p>
										<p>{purchaseAdapter.email}</p>
										<p>{purchaseAdapter.phone}</p>
										{homeDeliveryAddress(purchase?.info.type_retirement, purchaseAdapter.address)}

									</div>
								</Row>
								<Row justify="left">
									<CustomButton onClick={() => handleSendOrder()} className={'button-tertiary'} block>
										Reenviar Correo
									</CustomButton>
									<CustomButton onClick={() => handleReorder(purchase.products)} className={'button-secondary'} block style={{ marginBottom: '0' }}>
										Volver a comprar
									</CustomButton>
								</Row>
							</CustomCard>
						</Col>
						<Col md={8} xs={24}>
							<h4> Productos</h4>
							{purchase?.products.map((item, index) => {
								console.log('item', item)
								return (
									<React.Fragment key={`card-${index}`}>
										<CustomCard onClick={() => {
										}} className={'card-primary'}>
											<Row >
												<CustomImage src={item.quotation_type === 'magistral' ? 'https://storage.googleapis.com/tirx-resources-production/00080c94-4e35-4a6c-9160-e138060bcace.png' : handleOriginalImage(item.image)} width={50} />
											</Row>
											<Row justify="left" className={'disabled'}>
												<p>{item.laboratory}</p></Row>
											<Link className={'link-primary'} to={`/products/${item.slug}-farmacias-${item.pharmacy}`}>
												<Row justify="left">{item.editable_name}</Row>
											</Link>
											<Row justify="left" className={'title'} >
												<h4 style={{ marginBottom: '0' }}>{PRESCRYPTION_TYPE[item.prescryption_type]}</h4></Row>
											<Row justify="left"><p> Cantidad: <span style={{ fontWeight: '500' }}> {item.quantity}</span></p>
											</Row>
											<Row justify="left" style={{ marginBottom: '0' }}><p>Precio por unidad: <span
												style={{ fontWeight: '500' }}>${item?.quotation_price?.base_unit_price ||item.unit_price}</span></p>
											</Row>
												<Row justify="left" style={{ marginBottom: '0' }}><p>Descuento: <span
												style={{ fontWeight: '500' }}>${item?.quotation_price?.discount_amount || (+item.price - +item.promotion_price)}</span></p>
											</Row>
												<Row justify="left" style={{ marginBottom: '11px' }}><p>Precio final unitario: <span
												style={{ fontWeight: '500' }}>${ item?.quotation_price?.final_unit_price || item.promotion_price}</span></p>
											</Row>
											<CustomButton onClick={() => handleReorder(item)} className={'button-tertiary'} block style={{ marginBottom: '0' }}>
												Agregar a la bolsa
											</CustomButton>
										</CustomCard>
										<br></br>
									</React.Fragment>
								);
							})}
						</Col>
					</Row>
				</Col>
				<LoadingModal loading={isLoadingModal} visible={openLoadingModal} />
			</Row>
		</>
	);
}
